import React, { Component } from 'react';
import { Button, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
/* import SystemLabel from '../../../system/SystemLabel/SystemLabel'; */
import { history } from '../../../helpers/history';

class PageBug extends Component {
    render() {
        return (
            <div className="app flex-row align-items-center">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="6">
                            <span className="clearfix">
                                <h1 className="float-left display-3 mr-4"><i className="fa fa-bug" /></h1>
                                <h4 className="pt-3">An error occurred </h4>
                            </span>
                            <InputGroup className="input-prepend">
                                <Button color="info" onClick={() => history.push('/dashboard')}>Go to dashboard</Button>
                            </InputGroup>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default PageBug;
